import styled from 'styled-components/macro';

// import Grid component
import { Grid } from '../../styled';

const PortfolioFinancingContainer = styled(Grid)`
  padding: 25px 15px;
`;

export default PortfolioFinancingContainer;
